import classNames from "classnames";

type NoTextSelectionMenuProps = {
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
};

export default function NoTextSelectionMenu(props: NoTextSelectionMenuProps) {
  const className = classNames(NO_SELECTION_CLASS_NAME, props.className);
  return (
    <div className={className} style={props.style || {}}>
      {props.children}
    </div>
  );
}

export const NO_SELECTION_CLASS_NAME = "no-dictionary-selection";
